
export default {
    props: {
        options: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selected: undefined,
        }
    },
    computed: {
        current: {
            get() {
                return this.options.find((el) => el.id === this.$route.query['sort']) || this.options[0]
            },
            set(value) {
                this.$router.replace({ query: { ...this.$route.query, sort: value?.id } })
            },
        },
    },
    mounted() {
        this.setSelected()
    },
    methods: {
        selectOption(option) {
            this.selected = option
        },
        setSortingOption() {
            this.current = this.selected
            this.$nextTick(() => {
                this.$refs.sort.close()
            })
        }, // && ($route.query && $route.query.q) || currentTag
        setSelected() {
            if (this.selected?.id !== this.current?.id) this.selected = this.current
        },
    },
}
